import type { ReactElement, ReactNode } from "react";
import styles from "./LineItem.module.css";

export interface LineItemProps {
  /** Primary label (structure name, "Driveway install", …). */
  title: string;
  /** Right-aligned mono value (cost range, volume, …). */
  value: string;
  /** Optional small metric chips under the title (e.g. cut / fill / net). */
  metrics?: ReadonlyArray<{ label: string; value: string }>;
  /** Muted footnote (units, data source). */
  note?: ReactNode;
  /** Handset sheet sizing. */
  drawerRail?: boolean;
}

/**
 * Cost / quantity line for report bodies: title + mono value on one line,
 * optional metric chips, optional footnote. Replaces the ad-hoc "item
 * block" stacks in Site Work.
 */
export function LineItem({
  title,
  value,
  metrics,
  note,
  drawerRail = false
}: LineItemProps): ReactElement {
  return (
    <div className={`${styles.item}${drawerRail ? ` ${styles.itemDrawerRail}` : ""}`}>
      <div className={styles.head}>
        <span className={styles.title}>{title}</span>
        <span className={styles.value}>{value}</span>
      </div>
      {metrics != null && metrics.length > 0 ? (
        <div className={styles.metrics}>
          {metrics.map((m) => (
            <span key={m.label} className={styles.metric}>
              <span className={styles.metricLabel}>{m.label}</span>
              <span className={styles.metricValue}>{m.value}</span>
            </span>
          ))}
        </div>
      ) : null}
      {note != null ? <p className={styles.note}>{note}</p> : null}
    </div>
  );
}
